import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "react-feather";
import Logo from "./Logo";
import Breadcrumb from "./Breadcrumb";
import Notifications from "./Notifications";
import Account from "./Account";
import MobileMenu from "./MobileMenu";
import MainMenu from "./MainMenu";
import Search from "./Search";
import DarkMode from "../DarkMode";
import { useAuth } from "store/auth";

export default function Navbar() {
  const { dispatch, sidebar, toggleSideBar } = useAuth();

  return (
    <>
      <MobileMenu />
      <div className="border-b border-theme-29 -mt-10 md:-mt-5 -mx-3 sm:-mx-8 px-3 sm:px-8 pt-3 md:pt-0 mb-5">
        <div className="top-bar-boxed flex items-center">
          <Logo />
          <Breadcrumb />
          <DarkMode />
          <Search />
          <Notifications />
          <Account />
        </div>
      </div>
      {!sidebar && <MainMenu />}
    </>
  );
}
